
div.relative
  .float-right.d-flex.align-items-center
    a.btn.btn-sm.btn-default(v-on:click="fetch()" v-if='env == "test"'): fa(icon="refresh")
    |
    a.btn.btn-sm(v-on:click="toggleBm()" title="Vergleichen Sie Ihre Daten mit der Community" :class='{"btn-primary active": benchmarkMode, "btn-outline-primary": !benchmarkMode }' v-if='!hideBmButton')
      fa(icon="clone")
    a.btn.btn-sm(@click='toggleExtrapolate' :title="'Extrapolieren Sie die Daten auf die Gesamtzahl der Bewerber (Rücklaufquote: ' + returnRate + '%)'" :class='{"btn-primary active": extrapolate, "btn-outline-primary": !extrapolate }' v-if='extrapolateEnabled && returnRate')
      fa(icon="chart-line")
    slot(name='extra-buttons')
  br
  br
  pre(v-if='toggle'): code(v-html='response')
  loader(v-if='loading')
  highcharts(v-if='!loading && !error' :options="localChartOptions" v-bind:style="{ minHeight: (height||400)+'px' }" ref='chartEl')

  div.alert.alert-danger(v-if='!loading && error')
    |Fehler beim Abrufen, bitte probieren Sie es später noch einmal
  div.text-center(style='position: absolute; bottom: 5px; right: 0; left: 0; margin: 5px;' v-if='showUnselectAll')
    button.btn.btn.btn-outline-dark.btn-sm(@click.prevent='unselectAll')
      |Alle abwählen

